webpackJsonp([0,1,2,3,4,5,6,7,8,10,11,12,85,86,87,88,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123],{

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _poi_provider = __webpack_require__(77);

var _poi_provider2 = _interopRequireDefault(_poi_provider);

var _product_provider = __webpack_require__(78);

var _product_provider2 = _interopRequireDefault(_product_provider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBox = function (_Component) {
  _inherits(SearchBox, _Component);

  function SearchBox() {
    _classCallCheck(this, SearchBox);

    return _possibleConstructorReturn(this, (SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).apply(this, arguments));
  }

  _createClass(SearchBox, [{
    key: 'render',
    value: function render() {
      var searchEndpoint = this.props.searchEndpoint;

      return _react2.default.createElement(
        'div',
        null,
        searchEndpoint == '/products' && _react2.default.createElement(_product_provider2.default, { searchEndpoint: searchEndpoint }),
        searchEndpoint != '/products' && _react2.default.createElement(_poi_provider2.default, { searchEndpoint: searchEndpoint })
      );
    }
  }]);

  return SearchBox;
}(_react.Component);

SearchBox.propTypes = {
  searchEndpoint: _propTypes2.default.string.isRequired
};

exports.default = SearchBox;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleBox = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  padding: 20px 35px;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: #dae1f4;\n'], ['\n  padding: 20px 35px;\n  border-width: 1px 0 0;\n  border-style: solid;\n  border-color: #dae1f4;\n']);

var _styledComponents = __webpack_require__(3);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var ToggleBox = exports.ToggleBox = _styledComponents2.default.div(_templateObject);

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleCheckbox = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  width: 45px;\n  height: 28px;\n  float: right;\n\n  input {\n    display: none;\n  }\n\n  .toggle-switch {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 34px;\n    background: #c1c9de;\n    transition: .2s;\n  }\n\n  .toggle-switch:before {\n    position: absolute;\n    content: "";\n    height: 22px;\n    width: 22px;\n    left: 3px;\n    bottom: 3px;\n    background: white;\n    border-radius: 50%;\n    transition: .2s;\n  }\n\n  .active-toggle-switch {\n    background: #3ac1ee;\n  }\n\n  .active-toggle-switch:before {\n    left: -6px;\n  }\n\n  .active-toggle-switch {\n    box-shadow: 0 0 1px #2196F3;\n  }\n\n  .active-toggle-switch:before {\n    transform: translateX(26px);\n  }\n'], ['\n  position: relative;\n  display: inline-block;\n  width: 45px;\n  height: 28px;\n  float: right;\n\n  input {\n    display: none;\n  }\n\n  .toggle-switch {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 34px;\n    background: #c1c9de;\n    transition: .2s;\n  }\n\n  .toggle-switch:before {\n    position: absolute;\n    content: "";\n    height: 22px;\n    width: 22px;\n    left: 3px;\n    bottom: 3px;\n    background: white;\n    border-radius: 50%;\n    transition: .2s;\n  }\n\n  .active-toggle-switch {\n    background: #3ac1ee;\n  }\n\n  .active-toggle-switch:before {\n    left: -6px;\n  }\n\n  .active-toggle-switch {\n    box-shadow: 0 0 1px #2196F3;\n  }\n\n  .active-toggle-switch:before {\n    transform: translateX(26px);\n  }\n']);

var _styledComponents = __webpack_require__(3);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var ToggleCheckbox = exports.ToggleCheckbox = _styledComponents2.default.label(_templateObject);

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleLabel = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  width: 70%;\n  word-break: break-word;\n'], ['\n  display: inline-block;\n  width: 70%;\n  word-break: break-word;\n']);

var _styledComponents = __webpack_require__(3);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SearchLabel = __webpack_require__(6);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var ToggleLabel = exports.ToggleLabel = _SearchLabel.SearchLabel.extend(_templateObject);

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H3 = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 2.4rem;\n  font-weight: 600;\n  color: #000;\n'], ['\n  font-size: 2.4rem;\n  font-weight: 600;\n  color: #000;\n']);

var _styledComponents = __webpack_require__(3);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var H3 = exports.H3 = _styledComponents2.default.h3(_templateObject);

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initSearchBox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(62);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _searchBox = __webpack_require__(106);

var _searchBox2 = _interopRequireDefault(_searchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initSearchBox() {
  if ($('#search-box').length > 0) {
    var searchEndpoint = $('#search-box').data('search-endpoint');

    _reactDom2.default.render(_react2.default.createElement(_searchBox2.default, { searchEndpoint: searchEndpoint }), document.getElementById('search-box'));
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initSearchWidget;
function initSearchWidget() {
  var container = $('#searchWidget');
  var search,
      SearchWidget = {

    settings: {
      item: $('li', container),
      input: $('input', container),
      select: $('select', container),
      btn: $('button', container)
    },

    init: function init() {
      search = this.settings;
      this.switchSearchTypes();
      this.showSearchResults();
    },

    switchSearchTypes: function switchSearchTypes() {
      search.item.on('click', function (e) {
        search.link = $(this).find('a');
        search.type = search.link.attr('data-type');
        search.input.attr('placeholder', 'All' + ' ' + search.type);
        search.item.removeClass('active');
        $(this).addClass('active');
        e.preventDefault();
      });
    },

    showSearchResults: function showSearchResults() {
      var redirectToList = function redirectToList() {
        search.activeItem = $('.active a', container);
        search.url = search.activeItem.attr('data-url');
        search.value = search.input.val();
        search.city = search.select.val();
        window.location = '/' + search.url + '/?q=' + search.value + '&city[0]=' + search.city;
      };

      search.btn.on('click', function () {
        redirectToList();
      });

      search.input.keypress(function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
          redirectToList();
        }
      });
    }
  }.init();
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initSwiper;

var _swiper = __webpack_require__(258);

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function initSwiper() {
  var homeSwiper = new _swiper2.default('.swiper-container', {
    pagination: '.swiper-pagination',
    paginationClickable: true,
    simulateTouch: false,
    speed: 200,
    delay: 8000,
    loop: true
  });
}

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initLightGallery;
function initLightGallery() {
  $('.product-images, .poi-images').lightGallery({
    selector: 'a',
    getCaptionFromTitleOrAlt: false,
    download: false,
    speed: 0,
    startClass: ''
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initMobileMenu;
function initMobileMenu() {
  var $body = $('body'),
      $btnMenuTrigger = $('.js__btn-trigger-menu');

  // Open menu
  $btnMenuTrigger.on('click', function (event) {
    event.preventDefault();
    $(this).toggleClass('active');
    $body.toggleClass('mobile-menu__open');
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initBadgeCarousel;
function initBadgeCarousel() {
  $('.badge-swiper').slick({
    vertical: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    verticalSwiping: true,
    adaptiveHeight: true,
    arrows: true,
    mobileFirst: true,
    touchMove: false,
    prevArrow: $('.badge-swiper--prev'),
    nextArrow: $('.badge-swiper--next')
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initExpandContent;
function initExpandContent() {
  var $title = $('.js__expand--title');

  $title.on('click', function (event) {
    event.preventDefault();
    var $this = $(this),
        parent = $this.data('parent'),
        $elem = $(this).closest(parent);
    $elem.toggleClass('active');
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initCarousel;
function initCarousel() {
  // Where to buy
  $('#brand-carousel').owlCarousel({
    loop: false,
    responsiveClass: true,
    nav: true,
    navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 2
      },
      1000: {
        items: 3
      }
    }
  });

  // Mobile Product/POI images
  $('#mobile-product-images, #mobile-poi-images').owlCarousel({
    loop: false,
    nav: false,
    items: 2,
    dotsEach: true,
    stagePadding: 10,
    margin: 10,
    responsiveClass: true
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = IEObjectfitFallback;
function IEObjectfitFallback() {
  // IE & Edge fallback for object-fit images
  var image = $('.product-images__item, .poi-images__item, .swiper-slide, .showcase-row__img, .object-fit');

  if ('objectFit' in document.documentElement.style === false) {
    $.each(image, function () {
      var $imageWrap = $(this),
          imgUrl = $imageWrap.find('img').prop('src');

      if (imgUrl) {
        $imageWrap.css('backgroundImage', 'url(' + imgUrl + ')').addClass('objectfit-polyfill').find('img').css('visibility', 'hidden');
      }
    });
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initReviewForm;

__webpack_require__(256);

function initReviewForm() {
  var container = $('#addReview');
  if (container.length) {
    var review,
        ReviewForm = {

      settings: {
        viewport: $('html, body'),
        toggleBtn: $('.review-form__toggle'),
        date: $('.review-form__date input'),
        errorContainer: $('#errors'),
        errors: $('#errors ul')
      },

      init: function init() {
        review = this.settings;
        this.toggleForm();
        this.visitDate();
      },

      toggleForm: function toggleForm() {
        review.toggleBtn.on('click', function () {
          container.addClass('visible');
          review.viewport.animate({
            scrollTop: container.offset().top
          }, 0);
        });
      },

      visitDate: function visitDate() {
        review.date.flatpickr({
          altInput: true
        });
      }
    }.init();

    $('#new_review').submit(function (e) {
      $.ajax({
        type: 'POST',
        url: '/reviews',
        data: $('#new_review').serialize(),
        success: function success(data) {
          $('#addReview').hide();
          $('#completeReview').fadeIn(150);
        },
        error: function error(data) {
          var json = JSON.parse(data.responseText);
          var errorText = '';
          for (var key in json) {
            var obj = json[key];
            for (var prop in obj) {
              errorText += '<li>' + key + ' ' + obj[prop] + '</li>';
              break;
            }
            review.errors.html(errorText);
          }

          // Toggle classes
          if (json['title']) {
            var $this = $('#review_title');
            $this.addClass('error');
            $this.keypress(function () {
              $this.removeClass('error');
            });
          }
          if (json['comment']) {
            var _$this = $('#review_comment');
            _$this.addClass('error');
            _$this.keypress(function () {
              _$this.removeClass('error');
            });
          }
          review.errorContainer.show();
        }
      });
      e.preventDefault();
    });
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = socialShareButtons;
function socialShareButtons() {
  $('.fb').click(function () {
    var opt = 'width=800,height=500,left=200,top=300,menubar=no,status=no,location=no';
    var url = encodeURIComponent($(this).data('url') || '');
    window.open('https://facebook.com/sharer/sharer.php?u=' + url, 'popup', opt);
    return false;
  });
  $('.tw').click(function () {
    var opt = 'width=600,height=300,left=200,top=300,menubar=no,status=no,location=no';
    var text = encodeURIComponent($(this).data('text') || '');
    window.open('https://twitter.com/intent/tweet?text=' + text, 'popup', opt);
    return false;
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AvatarPreview;
function AvatarPreview() {
  $(function () {
    $('.img-avatar, .upload-btn').click(function (e) {
      $('#user_avatar').click();
    });
  });
  $('#user_avatar').on('change', function (e) {
    if (this.files && this.files[0]) {
      var reader = new window.FileReader();
    }
    reader.onload = function (e) {
      $('#avatar_upload, .img-avatar').attr('src', e.target.result);
    };

    reader.readAsDataURL(this.files[0]);
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initSelectize;

__webpack_require__(107);

function initSelectize() {
  $('.devise select').selectize({
    create: false
  });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchkit = __webpack_require__(4);

var _ToggleBox = __webpack_require__(12);

var _ToggleLabel = __webpack_require__(14);

var _ToggleCheckbox = __webpack_require__(13);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleSwitch = function ToggleSwitch(props) {
  var isActive = props.active;
  var toggleClass = (0, _classnames2.default)({
    'toggle-switch': true,
    'active-toggle-switch': isActive
  });
  return _react2.default.createElement(
    _ToggleBox.ToggleBox,
    null,
    _react2.default.createElement(
      _ToggleLabel.ToggleLabel,
      null,
      props.label
    ),
    _react2.default.createElement(
      _ToggleCheckbox.ToggleCheckbox,
      null,
      _react2.default.createElement('input', { type: 'checkbox' }),
      _react2.default.createElement('span', { className: toggleClass, onClick: props.onClick })
    )
  );
};

exports.default = ToggleSwitch;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchkit = __webpack_require__(4);

var _SearchLabel = __webpack_require__(6);

var _reactResponsive = __webpack_require__(31);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LayoutHeader = function (_Component) {
  _inherits(LayoutHeader, _Component);

  function LayoutHeader() {
    _classCallCheck(this, LayoutHeader);

    return _possibleConstructorReturn(this, (LayoutHeader.__proto__ || Object.getPrototypeOf(LayoutHeader)).apply(this, arguments));
  }

  _createClass(LayoutHeader, [{
    key: 'render',
    value: function render() {
      var Mobile = function Mobile(props) {
        return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { maxWidth: 1024 }));
      };

      return _react2.default.createElement(
        'div',
        { className: 'uk-container' },
        _react2.default.createElement(
          _searchkit.TopBar,
          null,
          _react2.default.createElement(
            Mobile,
            null,
            _react2.default.createElement(
              'h1',
              { className: 'uk-text-bold' },
              'Search Results'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'uk-grid' },
            _react2.default.createElement(
              'div',
              { className: 'uk-width-1-2@m uk-width-1-1@s m-margin-bt-20' },
              _react2.default.createElement(
                _SearchLabel.SearchLabel,
                null,
                'What'
              ),
              _react2.default.createElement(_searchkit.SearchBox, {
                searchOnChange: true,
                searchThrottleTime: 600,
                placeholder: 'What are you looking for?',
                prefixQueryFields: ["_all"],
                queryFields: ["_all"] })
            ),
            _react2.default.createElement(
              'div',
              { className: 'uk-width-1-2@m uk-width-1-1@s' },
              _react2.default.createElement(
                _SearchLabel.SearchLabel,
                null,
                'Where'
              ),
              _react2.default.createElement(_searchkit.MenuFilter, {
                id: 'city',
                field: 'city',
                listComponent: _searchkit.Select }),
              _react2.default.createElement(
                'button',
                { className: 'btn lg-btn primary-btn search-btn', onClick: this.reloadSearch },
                'Find'
              )
            )
          )
        )
      );
    }
  }]);

  return LayoutHeader;
}(_react.Component);

exports.default = LayoutHeader;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchkit = __webpack_require__(4);

var _Filters = __webpack_require__(30);

var _Filters2 = _interopRequireDefault(_Filters);

var _reactResponsive = __webpack_require__(31);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar(props) {
    _classCallCheck(this, Sidebar);

    var _this = _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this));

    _this.state = {
      filterVisible: false
    };
    return _this;
  }

  _createClass(Sidebar, [{
    key: 'toggleFilters',
    value: function toggleFilters() {
      this.setState({
        filterVisible: !this.state.filterVisible
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var Mobile = function Mobile(props) {
        return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { maxWidth: 960 }));
      };
      var filterVisible = this.state.filterVisible;
      var toggleFilter = (0, _classnames2.default)({
        'filters-hidden': !filterVisible,
        'filters-visible': filterVisible
      });

      return _react2.default.createElement(
        _searchkit.SideBar,
        null,
        _react2.default.createElement(
          Mobile,
          null,
          _react2.default.createElement(
            'h3',
            { onClick: function onClick() {
                return _this2.toggleFilters();
              } },
            'Filters'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: toggleFilter },
          _react2.default.createElement(_Filters2.default, this.props)
        )
      );
    }
  }]);

  return Sidebar;
}(_react.Component);

exports.default = Sidebar;

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchkit = __webpack_require__(4);

var _ToggleSwitch = __webpack_require__(24);

var _ToggleSwitch2 = _interopRequireDefault(_ToggleSwitch);

var _SearchLabel = __webpack_require__(6);

var _H = __webpack_require__(15);

var _ToggleBox = __webpack_require__(12);

var _ToggleLabel = __webpack_require__(14);

var _ToggleCheckbox = __webpack_require__(13);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filters = function (_Component) {
  _inherits(Filters, _Component);

  function Filters(props) {
    _classCallCheck(this, Filters);

    var _this = _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this));

    _this.state = {
      ratingVisible: false
    };
    return _this;
  }

  _createClass(Filters, [{
    key: 'toggleRating',
    value: function toggleRating() {
      this.setState({
        ratingVisible: !this.state.ratingVisible
      });
      if (this.state.ratingVisible) {
        $('.sk-item-list__item.is-active').each(function () {
          $(this).click();
        });
      } else {
        document.querySelector('.sk-item-list__item').click();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ifProduct = this.props.searchEndpoint == "/products",
          ifMosque = this.props.searchEndpoint == "/mosques";

      var ratingVisible = this.state.ratingVisible;
      var handleToggleSwitch = (0, _classnames2.default)({
        'toggle-switch': true,
        'active-toggle-switch': ratingVisible
      });

      var toggleRating = (0, _classnames2.default)({
        'rating-hidden': true,
        'rating-visible': ratingVisible
      });

      return _react2.default.createElement(
        'div',
        { id: 'filters' },
        _react2.default.createElement(
          'div',
          { className: 'sidebar-top' },
          _react2.default.createElement(
            _H.H3,
            null,
            'Filters'
          ),
          _react2.default.createElement(
            _SearchLabel.SearchLabel,
            null,
            'Sort by'
          ),
          !ifMosque && _react2.default.createElement(
            'div',
            { className: 'sidebar-sort' },
            _react2.default.createElement(_searchkit.SortingSelector, {
              options: [{ label: 'Relevance', field: '_score', order: 'desc' }, { label: 'Name', field: 'name', order: 'asc' }, { label: 'Rating', field: 'rating', order: 'desc' }, { label: 'Number of reviews', field: 'reviews_count', order: 'desc' }] })
          ),
          ifMosque && _react2.default.createElement(
            'div',
            { className: 'sidebar-sort' },
            _react2.default.createElement(_searchkit.SortingSelector, {
              options: [{ label: 'Relevance', field: '_score', order: 'desc' }, { label: 'Name', field: 'name', order: 'asc' }] })
          ),
          _react2.default.createElement(
            'div',
            { className: 'sidebar-filter-category' },
            ifProduct && !ifMosque && _react2.default.createElement(
              _SearchLabel.SearchLabel,
              null,
              'Category'
            ),
            _react2.default.createElement(_searchkit.MenuFilter, {
              id: 'category',
              field: 'category',
              listComponent: _searchkit.Select })
          ),
          _react2.default.createElement(
            'div',
            { className: 'sidebar-filter-store' },
            ifProduct && !ifMosque && _react2.default.createElement(
              _SearchLabel.SearchLabel,
              null,
              'Store'
            ),
            _react2.default.createElement(_searchkit.MenuFilter, {
              id: 'store',
              field: 'store',
              listComponent: _searchkit.Select })
          ),
          !ifMosque && _react2.default.createElement(
            'div',
            { className: 'rating-filter' },
            _react2.default.createElement(
              _ToggleBox.ToggleBox,
              null,
              _react2.default.createElement(
                _ToggleLabel.ToggleLabel,
                null,
                'Rating'
              ),
              _react2.default.createElement(
                _ToggleCheckbox.ToggleCheckbox,
                null,
                _react2.default.createElement('input', { type: 'checkbox' }),
                _react2.default.createElement('span', { className: handleToggleSwitch, onClick: function onClick() {
                    return _this2.toggleRating();
                  } })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: toggleRating },
              _react2.default.createElement(_searchkit.NumericRefinementListFilter, {
                id: 'positive_ratings_count',
                title: '',
                field: 'positive_ratings_count',
                multiselect: true,
                options: [{ title: '1', from: 1 }, { title: '50', from: 50 }, { title: '100', from: 100 }]
              })
            )
          )
        ),
        _react2.default.createElement(_searchkit.RefinementListFilter, {
          title: '',
          id: 'filters',
          field: 'filters',
          operator: 'AND',
          orderKey: '_term',
          itemComponent: _ToggleSwitch2.default
        })
      );
    }
  }]);

  return Filters;
}(_react.Component);

exports.default = Filters;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POIBadges = function POIBadges(props) {
  var badges = props._source.badges_urls;

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__badges' },
    badges.slice(0, 5).map(function (badge, i) {
      return _react2.default.createElement('img', { alt: props._source.name, src: badge, key: i });
    }),
    badges.length > 5 && _react2.default.createElement(
      'div',
      { className: 'more' },
      '+',
      badges.length - 5
    )
  );
};

POIBadges.propTypes = {
  _source: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    badges_urls: _propTypes2.default.array
  })
};

exports.default = POIBadges;

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _railsUjs = __webpack_require__(183);

var _railsUjs2 = _interopRequireDefault(_railsUjs);

__webpack_require__(2);

__webpack_require__(184);

__webpack_require__(389);

__webpack_require__(388);

__webpack_require__(390);

var _carousel = __webpack_require__(172);

var _carousel2 = _interopRequireDefault(_carousel);

var _expandContent = __webpack_require__(171);

var _expandContent2 = _interopRequireDefault(_expandContent);

var _mobileMenu = __webpack_require__(169);

var _mobileMenu2 = _interopRequireDefault(_mobileMenu);

var _lightGallery = __webpack_require__(168);

var _lightGallery2 = _interopRequireDefault(_lightGallery);

var _reviewForm = __webpack_require__(174);

var _reviewForm2 = _interopRequireDefault(_reviewForm);

var _IEObjectfitFallback = __webpack_require__(173);

var _IEObjectfitFallback2 = _interopRequireDefault(_IEObjectfitFallback);

var _social_share_buttons = __webpack_require__(175);

var _social_share_buttons2 = _interopRequireDefault(_social_share_buttons);

var _badgeCarousel = __webpack_require__(170);

var _badgeCarousel2 = _interopRequireDefault(_badgeCarousel);

var _searchBox = __webpack_require__(165);

var _searchBox2 = _interopRequireDefault(_searchBox);

var _swiper = __webpack_require__(167);

var _swiper2 = _interopRequireDefault(_swiper);

var _searchWidget = __webpack_require__(166);

var _searchWidget2 = _interopRequireDefault(_searchWidget);

var _selectize = __webpack_require__(182);

var _selectize2 = _interopRequireDefault(_selectize);

var _avatar_preview = __webpack_require__(181);

var _avatar_preview2 = _interopRequireDefault(_avatar_preview);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Init functions


// User


// Home


// Vendor
$(function () {
  (0, _carousel2.default)();
  (0, _expandContent2.default)();
  (0, _mobileMenu2.default)();
  (0, _swiper2.default)();
  (0, _searchWidget2.default)();
  (0, _lightGallery2.default)();
  (0, _searchBox2.default)();
  (0, _selectize2.default)();
  (0, _reviewForm2.default)();
  (0, _social_share_buttons2.default)();
  (0, _IEObjectfitFallback2.default)();
  (0, _avatar_preview2.default)();
  (0, _badgeCarousel2.default)();
});

// Search


// Shared


// Product & POI


_railsUjs2.default.start();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POICertification = function POICertification(props) {

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__certification' },
    _react2.default.createElement('img', { alt: props._source.name, src: props._source.certification_url })
  );
};

POICertification.propTypes = {
  _source: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    certification_url: _propTypes2.default.string
  })
};

exports.default = POICertification;

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POICost = function (_Component) {
  _inherits(POICost, _Component);

  function POICost(props) {
    _classCallCheck(this, POICost);

    return _possibleConstructorReturn(this, (POICost.__proto__ || Object.getPrototypeOf(POICost)).call(this));
  }

  _createClass(POICost, [{
    key: 'render',
    value: function render() {
      var maxCost = 4;
      var currentCost = this.props._source.cost,
          subtractCost = maxCost - currentCost;

      var activeCostSign = [].concat(_toConsumableArray(Array(currentCost))).map(function (i) {
        return _react2.default.createElement('div', { className: 'poi-details__prices-sign active', key: i });
      });

      var passiveCostSign = [].concat(_toConsumableArray(Array(subtractCost))).map(function (i) {
        return _react2.default.createElement('div', { className: 'poi-details__prices-sign', key: i });
      });

      var cost = [];
      cost.push(activeCostSign, passiveCostSign);

      return _react2.default.createElement(
        'div',
        { className: 'sk-hits-list-hit__cost' },
        cost
      );
    }
  }]);

  return POICost;
}(_react.Component);

POICost.propTypes = {
  _source: _propTypes2.default.shape({
    cost: _propTypes2.default.number
  })
};

exports.default = POICost;

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POICuisine = function POICuisine(props) {
  var cuisines = props._source.cuisines;

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__cuisines' },
    cuisines.slice(0, 2).map(function (cuisine, i) {
      return _react2.default.createElement(
        'div',
        { key: i },
        cuisine
      );
    })
  );
};

POICuisine.propTypes = {
  _source: _propTypes2.default.shape({
    cuisines: _propTypes2.default.array
  })
};

exports.default = POICuisine;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POIHotelStars = function (_Component) {
  _inherits(POIHotelStars, _Component);

  function POIHotelStars(props) {
    _classCallCheck(this, POIHotelStars);

    return _possibleConstructorReturn(this, (POIHotelStars.__proto__ || Object.getPrototypeOf(POIHotelStars)).call(this));
  }

  _createClass(POIHotelStars, [{
    key: 'render',
    value: function render() {
      var maxStars = 5;
      var currentStars = this.props._source.stars,
          subtractStars = maxStars - currentStars;

      var activeStar = [].concat(_toConsumableArray(Array(currentStars))).map(function (i) {
        return _react2.default.createElement('div', { className: 'poi-details__stars active', key: i });
      });

      var passiveStar = [].concat(_toConsumableArray(Array(subtractStars))).map(function (i) {
        return _react2.default.createElement('div', { className: 'poi-details__stars', key: i });
      });

      var hotel_stars = [];
      hotel_stars.push(activeStar, passiveStar);

      return _react2.default.createElement(
        'div',
        { className: 'sk-hits-list-hit__stars' },
        _react2.default.createElement(
          'div',
          null,
          hotel_stars
        )
      );
    }
  }]);

  return POIHotelStars;
}(_react.Component);

POIHotelStars.propTypes = {
  _source: _propTypes2.default.shape({
    stars: _propTypes2.default.number
  })
};

exports.default = POIHotelStars;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POIInfo = function POIInfo(props) {
  var POIType = props._type === 'attraction' ? 'things to do' : props._type;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('span', { className: 'sk-hits-list-hit__type', dangerouslySetInnerHTML: { __html: POIType } }),
    _react2.default.createElement('h2', { className: 'sk-hits-list-hit__title', dangerouslySetInnerHTML: { __html: props._source.name } })
  );
};

POIInfo.propTypes = {
  _type: _propTypes2.default.string.isRequired,
  _source: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired
  })
};

exports.default = POIInfo;

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POILogo = function POILogo(props) {

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__logo' },
    _react2.default.createElement('img', { alt: props._source.name, src: props._source.logo_url })
  );
};

POILogo.propTypes = {
  _source: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    logo_url: _propTypes2.default.string
  })
};

exports.default = POILogo;

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POIRating = function POIRating(props) {

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__rating' },
    _react2.default.createElement(
      'div',
      { className: 'sk-hits-list-hit__rating-top' },
      _react2.default.createElement(
        'div',
        { className: 'emoji' },
        _react2.default.createElement(
          'div',
          { className: 'emoji-item' },
          _react2.default.createElement('i', { className: 'happy' }),
          _react2.default.createElement(
            'div',
            { className: 'emoji__count' },
            props._source.positive_ratings_count
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'emoji-item' },
          _react2.default.createElement('i', { className: 'neutral' }),
          _react2.default.createElement(
            'div',
            { className: 'emoji__count' },
            props._source.neutral_ratings_count
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'emoji-item' },
          _react2.default.createElement('i', { className: 'sad' }),
          _react2.default.createElement(
            'div',
            { className: 'emoji__count' },
            props._source.negative_ratings_count
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'info' },
      'Rating'
    )
  );
};

POIRating.propTypes = {
  _source: _propTypes2.default.shape({
    positive_ratings_count: _propTypes2.default.number,
    neutral_ratings_count: _propTypes2.default.number,
    negative_ratings_count: _propTypes2.default.number
  })
};

exports.default = POIRating;

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POIReviewCount = function POIReviewCount(props) {

  return _react2.default.createElement(
    'div',
    { className: 'showcase-row__badge' },
    _react2.default.createElement('i', { className: 'fa fa-commenting-o', 'aria-hidden': 'true' }),
    _react2.default.createElement(
      'span',
      null,
      props._source.reviews_count
    )
  );
};

POIReviewCount.propTypes = {
  _source: _propTypes2.default.shape({
    reviews_count: _propTypes2.default.number
  })
};

exports.default = POIReviewCount;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductBadges = function ProductBadges(props) {
  var badges = props._source.badges_urls;

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__badges' },
    badges.slice(0, 5).map(function (badge, i) {
      return _react2.default.createElement('img', { alt: props._source.name, src: badge, key: i });
    }),
    badges.length > 5 && _react2.default.createElement(
      'div',
      { className: 'more' },
      '+',
      badges.length
    )
  );
};

ProductBadges.propTypes = {
  _source: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    badges_urls: _propTypes2.default.array
  })
};

exports.default = ProductBadges;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductCategory = function ProductCategory(props) {
  var ifSubCategoryExists = props._source.subcategory;

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__category' },
    _react2.default.createElement(
      'div',
      null,
      props._source.category
    ),
    ifSubCategoryExists && _react2.default.createElement(
      'div',
      null,
      props._source.subcategory
    )
  );
};

ProductCategory.propTypes = {
  _source: _propTypes2.default.shape({
    category: _propTypes2.default.string,
    subcategory: _propTypes2.default.string
  })
};

exports.default = ProductCategory;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductCertification = function ProductCertification(props) {

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__certification' },
    _react2.default.createElement('img', { alt: props._source.name, src: props._source.certification_url })
  );
};

ProductCertification.propTypes = {
  _source: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    certification_url: _propTypes2.default.string
  })
};

exports.default = ProductCertification;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductInfo = function ProductInfo(props) {

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('span', { className: 'sk-hits-list-hit__type', dangerouslySetInnerHTML: { __html: props._type } }),
    _react2.default.createElement('h2', { className: 'sk-hits-list-hit__title', dangerouslySetInnerHTML: { __html: props._source.name } })
  );
};

ProductInfo.propTypes = {
  _type: _propTypes2.default.string.isRequired,
  _source: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired
  })
};

exports.default = ProductInfo;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductManufacturer = function ProductManufacturer(props) {

  return _react2.default.createElement(
    'p',
    { className: 'sk-hits-list-hit__manufacturer' },
    props._source.manufacturer
  );
};

ProductManufacturer.propTypes = {
  _source: _propTypes2.default.shape({
    manufacturer: _propTypes2.default.string
  })
};

exports.default = ProductManufacturer;

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductRating = function ProductRating(props) {

  return _react2.default.createElement(
    'div',
    { className: 'sk-hits-list-hit__rating' },
    _react2.default.createElement(
      'div',
      { className: 'sk-hits-list-hit__rating-top' },
      _react2.default.createElement(
        'div',
        { className: 'emoji' },
        _react2.default.createElement(
          'div',
          { className: 'emoji-item' },
          _react2.default.createElement('i', { className: 'happy' }),
          _react2.default.createElement(
            'div',
            { className: 'emoji__count' },
            props._source.positive_ratings_count
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'emoji-item' },
          _react2.default.createElement('i', { className: 'neutral' }),
          _react2.default.createElement(
            'div',
            { className: 'emoji__count' },
            props._source.neutral_ratings_count
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'emoji-item' },
          _react2.default.createElement('i', { className: 'sad' }),
          _react2.default.createElement(
            'div',
            { className: 'emoji__count' },
            props._source.negative_ratings_count
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'info' },
      'Rating'
    )
  );
};

ProductRating.propTypes = {
  _source: _propTypes2.default.shape({
    positive_ratings_count: _propTypes2.default.number,
    neutral_ratings_count: _propTypes2.default.number,
    negative_ratings_count: _propTypes2.default.number
  })
};

exports.default = ProductRating;

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductReviewCount = function ProductReviewCount(props) {

  return _react2.default.createElement(
    'div',
    { className: 'showcase-row__badge' },
    _react2.default.createElement('i', { className: 'fa fa-commenting-o', 'aria-hidden': 'true' }),
    _react2.default.createElement(
      'span',
      null,
      props._source.review_count
    )
  );
};

ProductReviewCount.propTypes = {
  _source: _propTypes2.default.shape({
    reviews_count: _propTypes2.default.number
  })
};

exports.default = ProductReviewCount;

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchLabel = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  font-family: "proletarsk", Helvetica, sans-serif;\n  font-size: 1.8rem;\n  color: #acb4c9;\n  text-transform: uppercase;\n'], ['\n  display: block;\n  font-family: "proletarsk", Helvetica, sans-serif;\n  font-size: 1.8rem;\n  color: #acb4c9;\n  text-transform: uppercase;\n']);

var _styledComponents = __webpack_require__(3);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var SearchLabel = exports.SearchLabel = _styledComponents2.default.label(_templateObject);

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(57);

var _POIBadges = __webpack_require__(41);

var _POIBadges2 = _interopRequireDefault(_POIBadges);

var _POICertification = __webpack_require__(42);

var _POICertification2 = _interopRequireDefault(_POICertification);

var _POICost = __webpack_require__(43);

var _POICost2 = _interopRequireDefault(_POICost);

var _POICuisine = __webpack_require__(44);

var _POICuisine2 = _interopRequireDefault(_POICuisine);

var _POIInfo = __webpack_require__(46);

var _POIInfo2 = _interopRequireDefault(_POIInfo);

var _POILogo = __webpack_require__(47);

var _POILogo2 = _interopRequireDefault(_POILogo);

var _POIHotelStars = __webpack_require__(45);

var _POIHotelStars2 = _interopRequireDefault(_POIHotelStars);

var _POIRating = __webpack_require__(48);

var _POIRating2 = _interopRequireDefault(_POIRating);

var _POIReviewCount = __webpack_require__(49);

var _POIReviewCount2 = _interopRequireDefault(_POIReviewCount);

__webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POIListItem = function (_Component) {
  _inherits(POIListItem, _Component);

  function POIListItem(props) {
    _classCallCheck(this, POIListItem);

    return _possibleConstructorReturn(this, (POIListItem.__proto__ || Object.getPrototypeOf(POIListItem)).call(this));
  }

  _createClass(POIListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bemBlocks = _props.bemBlocks,
          result = _props.result;

      var resultType = result._type == 'attraction' ? 'things_to_do' : result._type + 's';
      var url = '/' + resultType + '/' + result._source.slug;
      var source = (0, _lodash.extend)({}, result._source, result.highlight);

      var ifHotel = result._type == "hotel",
          ifMosque = result._type == "mosque";

      var ifBadgesExists = result._source.badges_urls.length >= 1,
          ifCertificationExists = result._source.certification_url,
          ifCuisineExists = result._source.cuisines,
          ifLogoExists = result._source.logo_url,
          ifStarsExists = result._source.stars,
          ifCostExists = result._source.cost,
          ifReviewExists = result._source.reviews_count >= 1;

      return _react2.default.createElement(
        'a',
        { href: url, className: bemBlocks.item().mix(bemBlocks.container('item')), 'data-qa': 'hit' },
        _react2.default.createElement(
          'div',
          { className: bemBlocks.item('poster') },
          _react2.default.createElement('img', { alt: 'presentation', 'data-qa': 'poster', src: result._source.photo_url }),
          ifReviewExists && _react2.default.createElement(_POIReviewCount2.default, result)
        ),
        _react2.default.createElement(
          'div',
          { className: bemBlocks.item('details') },
          _react2.default.createElement(_POIInfo2.default, result),
          ifCuisineExists && _react2.default.createElement(_POICuisine2.default, result),
          ifHotel && ifStarsExists && _react2.default.createElement(_POIHotelStars2.default, result),
          !ifHotel && ifCostExists && _react2.default.createElement(_POICost2.default, result),
          ifBadgesExists && _react2.default.createElement(_POIBadges2.default, result)
        ),
        _react2.default.createElement(
          'div',
          { className: bemBlocks.item('mid-column') },
          ifLogoExists && _react2.default.createElement(_POILogo2.default, result),
          ifCertificationExists && _react2.default.createElement(_POICertification2.default, result)
        ),
        !ifMosque && _react2.default.createElement(_POIRating2.default, result)
      );
    }
  }]);

  return POIListItem;
}(_react.Component);

exports.default = POIListItem;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(57);

var _ProductBadges = __webpack_require__(50);

var _ProductBadges2 = _interopRequireDefault(_ProductBadges);

var _ProductCategory = __webpack_require__(51);

var _ProductCategory2 = _interopRequireDefault(_ProductCategory);

var _ProductCertification = __webpack_require__(52);

var _ProductCertification2 = _interopRequireDefault(_ProductCertification);

var _ProductInfo = __webpack_require__(53);

var _ProductInfo2 = _interopRequireDefault(_ProductInfo);

var _ProductManufacturer = __webpack_require__(54);

var _ProductManufacturer2 = _interopRequireDefault(_ProductManufacturer);

var _ProductRating = __webpack_require__(55);

var _ProductRating2 = _interopRequireDefault(_ProductRating);

var _ProductReviewCount = __webpack_require__(56);

var _ProductReviewCount2 = _interopRequireDefault(_ProductReviewCount);

__webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductListItem = function (_Component) {
  _inherits(ProductListItem, _Component);

  function ProductListItem(props) {
    _classCallCheck(this, ProductListItem);

    return _possibleConstructorReturn(this, (ProductListItem.__proto__ || Object.getPrototypeOf(ProductListItem)).call(this));
  }

  _createClass(ProductListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bemBlocks = _props.bemBlocks,
          result = _props.result;

      var url = '/products/' + result._source.slug;
      var source = (0, _lodash.extend)({}, result._source, result.highlight);

      var ifBadgesExists = result._source.badges_urls.length >= 1,
          ifCategoryExists = result._source.category,
          ifSubCategoryExists = result._source.subcategory,
          ifCertificationExists = result._source.certification_url,
          ifManufacturerExists = result._source.manufacturer,
          ifReviewExists = result._source.reviews_count >= 1;

      return _react2.default.createElement(
        'a',
        { href: url, className: bemBlocks.item().mix(bemBlocks.container('item')), 'data-qa': 'hit' },
        _react2.default.createElement(
          'div',
          { className: bemBlocks.item('poster') },
          _react2.default.createElement('img', { alt: 'presentation', 'data-qa': 'poster', src: result._source.photo_url }),
          ifReviewExists && _react2.default.createElement(_ProductReviewCount2.default, result)
        ),
        _react2.default.createElement(
          'div',
          { className: bemBlocks.item('details') },
          _react2.default.createElement(_ProductInfo2.default, result),
          _react2.default.createElement(
            'div',
            null,
            ifCategoryExists && _react2.default.createElement(_ProductCategory2.default, result),
            ifManufacturerExists && _react2.default.createElement(_ProductManufacturer2.default, result)
          ),
          ifBadgesExists && _react2.default.createElement(_ProductBadges2.default, result)
        ),
        _react2.default.createElement(
          'div',
          { className: bemBlocks.item('mid-column') },
          ifCertificationExists && _react2.default.createElement(_ProductCertification2.default, result)
        ),
        _react2.default.createElement(_ProductRating2.default, result)
      );
    }
  }]);

  return ProductListItem;
}(_react.Component);

exports.default = ProductListItem;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchkit = __webpack_require__(4);

__webpack_require__(22);

var _poi_list_item = __webpack_require__(64);

var _poi_list_item2 = _interopRequireDefault(_poi_list_item);

var _LayoutHeader = __webpack_require__(25);

var _LayoutHeader2 = _interopRequireDefault(_LayoutHeader);

var _Sidebar = __webpack_require__(26);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _H = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POIProvider = function (_Component) {
  _inherits(POIProvider, _Component);

  function POIProvider(props) {
    _classCallCheck(this, POIProvider);

    var _this = _possibleConstructorReturn(this, (POIProvider.__proto__ || Object.getPrototypeOf(POIProvider)).call(this, props));

    _this.searchkit = new _searchkit.SearchkitManager(props.searchEndpoint);
    return _this;
  }

  _createClass(POIProvider, [{
    key: 'reloadSearch',
    value: function reloadSearch() {
      searchkit.reloadSearch();
    }
  }, {
    key: 'render',
    value: function render() {
      var searchEndpoint = this.props.searchEndpoint;

      return _react2.default.createElement(
        _searchkit.SearchkitProvider,
        { searchkit: this.searchkit },
        _react2.default.createElement(
          _searchkit.Layout,
          null,
          _react2.default.createElement(_LayoutHeader2.default, null),
          _react2.default.createElement(
            _searchkit.LayoutBody,
            null,
            _react2.default.createElement(
              'div',
              { className: 'uk-container uk-flex reverse-column' },
              _react2.default.createElement(
                _searchkit.LayoutResults,
                null,
                _react2.default.createElement(_searchkit.ViewSwitcherHits, {
                  hitsPerPage: 5,
                  highlightFields: ['name', 'description'],
                  sourceFilter: ['name', 'photo_url', '_type', 'certification_url', 'city', 'tags', 'badges_urls', 'cost', 'emojis_count', 'stars', 'logo_url', 'cuisines', 'reviews_count', 'slug', 'positive_ratings_count', 'negative_ratings_count', 'neutral_ratings_count'],
                  hitComponents: [{ key: 'list', title: 'List', itemComponent: _poi_list_item2.default }],
                  scrollTo: 'body'
                }),
                _react2.default.createElement(_searchkit.NoHits, { suggestionsField: 'name' }),
                _react2.default.createElement(_searchkit.Pagination, { showNumbers: true, pageScope: 1 })
              ),
              _react2.default.createElement(_Sidebar2.default, { searchEndpoint: searchEndpoint })
            )
          )
        )
      );
    }
  }]);

  return POIProvider;
}(_react.Component);

exports.default = POIProvider;

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchkit = __webpack_require__(4);

__webpack_require__(23);

var _product_list_item = __webpack_require__(65);

var _product_list_item2 = _interopRequireDefault(_product_list_item);

var _LayoutHeader = __webpack_require__(25);

var _LayoutHeader2 = _interopRequireDefault(_LayoutHeader);

var _Sidebar = __webpack_require__(26);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _H = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductProvider = function (_Component) {
  _inherits(ProductProvider, _Component);

  function ProductProvider(props) {
    _classCallCheck(this, ProductProvider);

    var _this = _possibleConstructorReturn(this, (ProductProvider.__proto__ || Object.getPrototypeOf(ProductProvider)).call(this, props));

    _this.searchkit = new _searchkit.SearchkitManager(props.searchEndpoint);
    return _this;
  }

  _createClass(ProductProvider, [{
    key: 'reloadSearch',
    value: function reloadSearch() {
      searchkit.reloadSearch();
    }
  }, {
    key: 'render',
    value: function render() {
      var searchEndpoint = this.props.searchEndpoint;

      return _react2.default.createElement(
        _searchkit.SearchkitProvider,
        { searchkit: this.searchkit },
        _react2.default.createElement(
          _searchkit.Layout,
          null,
          _react2.default.createElement(_LayoutHeader2.default, null),
          _react2.default.createElement(
            _searchkit.LayoutBody,
            null,
            _react2.default.createElement(
              'div',
              { className: 'uk-container uk-flex reverse-column' },
              _react2.default.createElement(
                _searchkit.LayoutResults,
                null,
                _react2.default.createElement(_searchkit.ViewSwitcherHits, {
                  hitsPerPage: 5,
                  highlightFields: ['name', 'description'],
                  sourceFilter: ['name', 'photo_url', 'certification_url', 'city', 'tags', 'badges_urls', 'reviews_count', 'slug', 'category', 'subcategory', 'manufacturer', 'positive_ratings_count', 'negative_ratings_count', 'neutral_ratings_count'],
                  hitComponents: [{ key: 'list', title: 'List', itemComponent: _product_list_item2.default }],
                  scrollTo: 'body'
                }),
                _react2.default.createElement(_searchkit.NoHits, { suggestionsField: 'name' }),
                _react2.default.createElement(_searchkit.Pagination, { showNumbers: true, pageScope: 1 })
              ),
              _react2.default.createElement(_Sidebar2.default, { searchEndpoint: searchEndpoint })
            )
          )
        )
      );
    }
  }]);

  return ProductProvider;
}(_react.Component);

exports.default = ProductProvider;

/***/ })

},[412]);


// WEBPACK FOOTER //
// application-1e4b4154914b6e8df6f2.js